import { Box, Button, Container, Flex, Heading, ScrollArea, Text, TextField } from "@radix-ui/themes"
import React, { useEffect, useRef, useState } from "react"
import Avatar from "./avatar-render"
import {IMessage} from '../../../core/types/services-types/messages-types'
import MessageRender from "./message-render"
import { ArrowDownIcon, ArrowLeftIcon, PaperPlaneIcon } from "@radix-ui/react-icons"
import { IUser } from "../../../core/types/services-types/user-types"
import useObserver from '../../../hooks/useObserver'
import { Link } from "react-router"



export interface ChatRenderProps {
   data: IUser,
   messages: IMessage[],
   message: string,
   setMessage: (message: string) => any,
   sendMessage: () => Promise<any>,
   onBack: () => void,
   setPageMessages: (page: number) => any,
   totalMessages: number,
   pageMessages: number,
   isLoading: boolean
}


export default function ChatRender(props: ChatRenderProps) {
    const {data, messages, message, sendMessage, setMessage, onBack, setPageMessages, totalMessages, isLoading, pageMessages} = props
    let refScrollArea = useRef<HTMLDivElement>(null)
    const refUpChat = useRef<HTMLDivElement>(null)
    const [showArrowScroll, setShowArrowScroll] = useState<boolean>(false)
    const onClickArrowScrollToBottom = () => {
        refScrollArea.current?.scrollTo({top: refScrollArea.current.scrollHeight, behavior: 'smooth'})
    }
    const isScrolledToBottom = (element: HTMLElement) => {
        return element.scrollHeight - element.scrollTop === element.clientHeight;
    };
    useEffect(() => {
        onClickArrowScrollToBottom()
    }, [messages.length])
    useEffect(() => {
        console.log('scroll')
        if(refScrollArea.current) {
         refScrollArea.current.addEventListener('scroll', e => {
            if(refScrollArea.current) setShowArrowScroll(!isScrolledToBottom(refScrollArea.current))
         })
        }
    }, [refScrollArea.current])
    
    useObserver({
        ref: refUpChat,
        canLoad: totalMessages > messages.length || messages.length <= 0,
        isLoading: isLoading,
        callback: () => setPageMessages(pageMessages + 1)
    })


    return (
        <Container className="wrapper border max-w-[100%]"> 
        <Container className="heading-chat">
            <Flex align={'center'} justify={'start'} className="p-2"> 
            <Button variant='ghost' className="!block md:!hidden !ml-2 !mr-2" onClick={() => onBack()}>
                <ArrowLeftIcon />
            </Button>
            <Avatar name={data.login || 'U'} />
            <Box> 
            <Heading size={'4'}>
                <Link color='gray' to={`/profile/${data.id}`}> 
                {data.login}
                </Link>
            </Heading>
            <Text>{data.role === "admin" ? "Админ" : "Пользователь"}</Text>
            </Box>
            </Flex>
        </Container>
        <hr />
        <Flex direction={'column'} justify={'between'}>
        <ScrollArea 
        type="always" 
        scrollbars="vertical" 
        style={{height: '630px'}} 
        className="p-5 min-h-[600px]"
        ref={refScrollArea}
        >
            <Container className="end-chats" ref={refUpChat}></Container>
            {
            messages.map(item => {
                return (
                    <Container className="mb-5"> 
                    <MessageRender 
                    data={item}
                    />
                    </Container>
                )
            })
            }
            <Button variant='surface' className={`${showArrowScroll ? "!absolute !bottom-10 !right-5" : '!hidden'}`} onClick={() => onClickArrowScrollToBottom()}>
                <ArrowDownIcon />
            </Button>
        </ScrollArea>
        <Container>
            <Flex> 
            <TextField.Root className="container" placeholder="Отправить сообщение" value={message} onChange={e => setMessage(e.target.value)}>
            </TextField.Root>
            <Button onClick={() => sendMessage()}>
                <PaperPlaneIcon />
            </Button>
            </Flex>
        </Container>
        </Flex>
        </Container>
    )
}